import { ReactElement, memo } from 'react';
import * as S from './ExpiredCart.styles';
import { IApiCartItem } from '@/entities/Cart/domain/Cart.domain';
import { Block } from '@/common/ui';
import Link from 'next/link';

type ExpiredCartProps = {
    items: IApiCartItem[];
};

const ExpiredCartContainer = ({ items }: ExpiredCartProps): ReactElement => {
    return (
        <Block>
            <S.Title>Your Cart has Expired</S.Title>
            <S.Subtitle>Here are the activities that have expired</S.Subtitle>
            {items.map(({ id, product_url, product_name }) => {
                return (
                    <Link href={product_url.toLowerCase()} key={id} passHref>
                        <S.ProductLink>{product_name}</S.ProductLink>
                    </Link>
                );
            })}
        </Block>
    );
};

export const ExpiredCart = memo(ExpiredCartContainer);
